import { useTranslation } from 'react-i18next'

import { usePrefsStore } from '../store/prefsStore'
import { resolveMode, useThemeStore } from '../store/themeStore'

/**
 * The site's language and theme switches, shared by SiteShell's header and
 * the sign-in page's AuthFrame so the two never drift. The language one is
 * the same manual choice as Settings (`prefsStore.setLanguage`), so it
 * overrides the geo-IP default; `languageLocked` (an Iranian visitor) means
 * no language switch is offered at all (lib/geoLocale.js).
 */
export function useSiteToggles() {
  const { i18n } = useTranslation()
  const setLanguage = usePrefsStore((s) => s.setLanguage)
  const languageLocked = usePrefsStore((s) => s.languageLocked)
  const mode = useThemeStore((s) => s.mode)
  const setMode = useThemeStore((s) => s.setMode)
  const dark = resolveMode(mode) === 'dark'
  const language = i18n.resolvedLanguage ?? i18n.language
  return {
    language,
    dark,
    languageLocked,
    toggleLanguage: () => setLanguage(language === 'fa' ? 'en' : 'fa'),
    toggleTheme: () => setMode(dark ? 'light' : 'dark'),
  }
}
